import { ethers } from "ethers";
import { getCurrentContractAddresses } from "src/configs/address";
import { environment } from "src/configs/constance";
import MultiCallABI from "src/contract-logic/abis/MultiCallABI.json";
import { NETWORKS } from "src/configs/connection-config";

const sidemultiCall = async (abi, calls) => {
  const { SIDE_MULTI_CALL } = getCurrentContractAddresses();
  let _provider =
    environment == "testnet"
      ? new ethers.providers.JsonRpcProvider(NETWORKS.SEPOLIA.rpcUrls[0])
      : new ethers.providers.JsonRpcProvider(NETWORKS.ETH_MAINNET.rpcUrls[0]);
  const multi = new ethers.Contract(SIDE_MULTI_CALL, MultiCallABI, _provider);
  const itf = new ethers.utils.Interface(abi);

  const callData = calls.map((call) => [call.address.toLowerCase(), itf.encodeFunctionData(call.name, call.params)]);
  const { returnData } = await multi.aggregate(callData);
  return returnData.map((call, i) => itf.decodeFunctionResult(calls[i].name, call));
};

export default sidemultiCall;
